import { apiClient } from "@/lib/api/client";
import { apiPaths } from "@/lib/api/paths";
import useSWR, { type SWRConfiguration } from "swr";
import { config } from "@/config";
import { isEmpty } from "@utils/formatters";
import type { GetNotificationsResponse, NotificationFilters } from "./type";

async function getNotifications(
  query: NotificationFilters,
): Promise<GetNotificationsResponse> {
  const params = new URLSearchParams();

  Object.entries(query).forEach(([key, value]) => {
    if (isEmpty(value)) return;
    params.append(key, String(value));
  });

  let url = apiPaths.notifications.list;
  if (params.toString()) {
    url += `?${params.toString()}`;
  }

  const response = await apiClient.get<GetNotificationsResponse>(url);

  return response.data;
}

export function useGetNotifications(
  query: NotificationFilters | null,
  options?: SWRConfiguration,
) {
  const mergedOptions: SWRConfiguration = {
    ...config.swr,
    ...options,
  };

  return useSWR(
    [`fetch-get-notifications`, JSON.stringify(query ?? {})],
    () => getNotifications(query ?? {}),
    mergedOptions,
  );
}
